const OR = (a, b) => a | b;
export default OR;
